/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {TagDefinition} from "../models/tag-definition";
import {TagService} from "../services/tag.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class TagDefinitionsResolver implements Resolve<TagDefinition[]> {

  constructor(
    private mTagService: TagService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<TagDefinition[]> {
    try {
      return await this.mTagService.getAllTagDefinitions();
    } catch (error) {
      console.error("Problem resolving Tag Definitions... Error: " + error, error);
    }
  }

}
